import { render, staticRenderFns } from "./NeedStartupsTable.vue?vue&type=template&id=0eee154f&scoped=true&"
import script from "./NeedStartupsTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./NeedStartupsTable.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eee154f",
  null
  
)

export default component.exports